module.exports = __webpack_public_path__ + "img/footer-logo3.1aec1720.png";